<script>
import { Doughnut, mixins } from 'vue-chartjs';
import chartMixins from '../../../mixins/charts';

const { reactiveProp } = mixins;

export default Doughnut.extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted() {
    this.addPlugin(chartMixins.plugins.emptyDataPlugin);
    this.renderChart(this.chartData, this.options);
  },
});
</script>



// WEBPACK FOOTER //
// AnalyticsDoughnutChart.vue?454805e2